<template>
  <fieldset class="content-group">
    <div>
      <p class="text-muted mb-1">
        {{ $t(`${tt}.name`) }}
      </p>
      <h5 class="font-size-14">
        {{ contactName }}
      </h5>
    </div>
    <div v-if="!!params.email">
      <p class="text-muted mb-1">
        {{ $t(`${tt}.email`) }}
      </p>
      <h5 class="font-size-14">
        {{ params.email }}
      </h5>
    </div>
    <div v-if="!!params.birth_day">
      <p class="text-muted mb-1">
        {{ $t(`${tt}.birth_day`) }}
      </p>
      <h5 class="font-size-14">
        {{ params.birth_day }}
      </h5>
    </div>
    <div v-if="!!params.code">
      <p class="text-muted mb-1">
        {{ $t(`${tt}.code`) }}
      </p>
      <h5 class="font-size-14">
        {{ params.code }}
      </h5>
    </div>
    <div v-if="!!params.sum">
      <p class="text-muted mb-1">
        {{ $t(`${tt}.sum`) }}
      </p>
      <h5 class="font-size-14">
        {{ params.sum }}
      </h5>
    </div>
    <div v-if="!!params.date">
      <p class="text-muted mb-1">
        {{ $t(`${tt}.date`) }}
      </p>
      <h5 class="font-size-14">
        {{ params.date }}
      </h5>
    </div>
    <div v-if="!!params.param_1">
      <p class="text-muted mb-1">
        {{ $t(`${tt}.param_1`) }}
      </p>
      <h5 class="font-size-14">
        {{ params.param_1 }}
      </h5>
    </div>
    <div v-if="!!params.param_2">
      <p class="text-muted mb-1">
        {{ $t(`${tt}.param_2`) }}
      </p>
      <h5 class="font-size-14">
        {{ params.param_2 }}
      </h5>
    </div>
    <div v-if="!!params.param_3">
      <p class="text-muted mb-1">
        {{ $t(`${tt}.param_3`) }}
      </p>
      <h5 class="font-size-14">
        {{ params.param_3 }}
      </h5>
    </div>
  </fieldset>
</template>

<script>
import {fullName} from "../../../../utils/contactName";

export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    tt: 'room.header.add_contact.form',
  }),
  computed: {
    contactName() {
      if (this.params.name.length) return this.params.name;

      const name = fullName(this.params);
      if (name.length) return name;

      return ''
    },
  },
};
</script>

<style scoped>

</style>
